import { Eye, EyeOff } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function EvidenceBoundary({ shared, withheld }) {
  return (
    <div data-testid="evidence-boundary" className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Shared for review */}
      <div className="border border-emerald-500/30 bg-emerald-500/5 p-4 space-y-3">
        <div className="flex items-center gap-2 mb-1">
          <Eye className="h-4 w-4 text-emerald-400" strokeWidth={1.5} />
          <span className="text-[10px] uppercase tracking-widest text-emerald-400 font-semibold">
            Shared for review
          </span>
          <Badge className="rounded-none text-[9px] font-mono bg-emerald-500/10 text-emerald-400 border-emerald-500/20 ml-auto">
            {shared?.length || 0} refs
          </Badge>
        </div>
        {shared?.map((item, i) => (
          <div key={i} className="border border-zinc-800 bg-zinc-900/80 p-3">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-[10px] font-mono text-blue-400">{item.ref}</span>
              <span className="text-xs font-medium text-zinc-200">{item.title}</span>
            </div>
            <p className="text-[11px] text-zinc-500 leading-relaxed">{item.description}</p>
          </div>
        ))}
      </div>

      {/* Withheld / internal only */}
      <div className="border border-amber-500/30 bg-amber-500/5 p-4 space-y-3">
        <div className="flex items-center gap-2 mb-1">
          <EyeOff className="h-4 w-4 text-amber-400" strokeWidth={1.5} />
          <span className="text-[10px] uppercase tracking-widest text-amber-400 font-semibold">
            Withheld / internal only
          </span>
          <Badge className="rounded-none text-[9px] font-mono bg-amber-500/10 text-amber-400 border-amber-500/20 ml-auto">
            {withheld?.length || 0} items
          </Badge>
        </div>
        {withheld?.map((item, i) => (
          <div key={i} className="border border-zinc-800 bg-zinc-900/80 p-3">
            <div className="flex items-center gap-2 mb-1">
              <EyeOff className="h-3 w-3 text-amber-500/60" strokeWidth={1.5} />
              <span className="text-xs font-medium text-zinc-300">{item.label}</span>
            </div>
            <p className="text-[11px] text-zinc-600 leading-relaxed">{item.reason}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
